import '../styles/ShowDashboard.css';
import { withNavigation }              from 'components/App/withNavigation';
import { WithNavigationProps }         from 'components/App/withNavigation';
import React                           from 'react';
import { observer }                    from 'mobx-react';
import { Button }                      from 'antd';
import { Col }                         from 'antd';
import { notification }                from 'antd';
import Row                             from 'components/App/Row';
import { privateLayoutStore }          from 'stores/index';
import ShowDashboardContent            from '../components/ShowDashboardContent';
import ShowDashboardInformationsBox    from '../components/ShowDashboardPlansInformationsBox';
import currentSession                  from 'utils/currentSession';
import ShowSyncModel                   from 'models/ShowSyncModel';
import ShowDashboardProviderShowsBox   from '../components/ShowDashboardProviderShowsBox';
import ShowDashboardAdvertiserShowsBox from '../components/ShowDashboardAdvertiserShowsBox';
import FormattedMessageWrapper         from 'components/App/FormattedMessageWrapper';
import { showDashboardStore }          from 'stores/index';
import PageTitle                       from 'components/App/PageTitle';
import rights                          from 'utils/rights';
import { formatMessageIntl }           from 'utils/messageIntl';

interface ShowDashboardState {
  dataLoading: boolean;
  synchronized: boolean;
}

@observer
class ShowDashboard extends React.Component<WithNavigationProps> {
  public state: ShowDashboardState = {
    dataLoading: false,
    synchronized: false,
  };

  public async componentDidMount() {
    const { showId } = this.props.params;

    if (!rights.for.show.view) {
      // doesn't work without the timeout, page is stucked in loading
      setTimeout(() => this.props.navigate(`/salons/${showId}/stands`), 0);
      return;
    }

    try {
      await privateLayoutStore.setCurrentShowId(showId);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    await this.fetchData(this.props);
  }

  public async componentDidUpdate(prevProps: WithNavigationProps) {
    const { showId: prevShowId } = prevProps.params;
    const { showId } = this.props.params;

    if (prevShowId && prevShowId !== showId) {
      try {
        await privateLayoutStore.setCurrentShowId(showId);
      } catch (error: any) {
        if (error.name === 'show_not_found') {
          this.props.navigate('/404');
        }

        if (error.name === 'get_show_unauthorized') {
          this.props.navigate('/erreur');
        }

        return;
      }

      await this.fetchData(this.props);
    }
  }

  public render() {
    const { showId } = this.props.params;

    return (
      <>
        <div className="page-loading">
          {this.state.dataLoading && (
            <Button htmlType="button" loading>
              <FormattedMessageWrapper id="Chargement" />
            </Button>
          )}
        </div>

        {showDashboardStore.showModel && (
          <div>
            <PageTitle title={<FormattedMessageWrapper id="Tableau de bord du salon" />} />

            <Row>
              <Col lg={12} md={24}>
                <Row>
                  <Col span={24}>
                    <ShowDashboardContent
                      synchronize={this.synchronize}
                      synchronized={this.state.synchronized}
                    />
                  </Col>

                  <Col span={12}>
                    <ShowDashboardProviderShowsBox />
                  </Col>

                  <Col span={12}>
                    <ShowDashboardAdvertiserShowsBox />
                  </Col>
                </Row>
              </Col>

              <Col lg={12} md={24}>
                <ShowDashboardInformationsBox
                  id={showId}
                  totalStandCollectionWarning={showDashboardStore.showModel.get(
                    'nbInProgressReports',
                    0,
                  )}
                  totalStandCollectionWarningClosed={showDashboardStore.showModel.get(
                    'nbClosedReports',
                    0,
                  )}
                />

                {/*<Col span={24}>*/}
                {/*  <ShowDashboardDemandsInformationsBox*/}
                {/*    history={this.props.history}*/}
                {/*    id={this.props.match.params.id}*/}
                {/*    totalStandCollectionWarning={showDashboardStore.showModel.get(*/}
                {/*      'nbInProgressReports',*/}
                {/*      0,*/}
                {/*    )}*/}
                {/*    totalStandCollectionWarningClosed={showDashboardStore.showModel.get(*/}
                {/*      'nbClosedReports',*/}
                {/*      0,*/}
                {/*    )}*/}
                {/*  />*/}
                {/*</Col>*/}
                {/*<Col span={24}>*/}
                {/*  <ShowDashboardDocumentsInformationsBox*/}
                {/*    history={this.props.history}*/}
                {/*    id={this.props.match.params.id}*/}
                {/*    totalStandCollectionWarning={showDashboardStore.showModel.get(*/}
                {/*      'nbInProgressReports',*/}
                {/*      0,*/}
                {/*    )}*/}
                {/*    totalStandCollectionWarningClosed={showDashboardStore.showModel.get(*/}
                {/*      'nbClosedReports',*/}
                {/*      0,*/}
                {/*    )}*/}
                {/*  />*/}
                {/*</Col>*/}
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  private fetchData = async (props: WithNavigationProps) => {
    this.setState({ dataLoading: true });

    const { showId } = props.params;

    try {
      await showDashboardStore.load(showId);
    } catch (error: any) {
      const requestStatus = error?.connectorError?.request?.status || error?.connectorError?.response?.status;

      if (requestStatus === 401) {
        this.props.navigate('/logout');
      } else if (requestStatus === 404 || requestStatus === 405) {
        this.props.navigate('/404');
      } else {
        this.props.navigate('/erreur');
      }
    } finally {
      this.setState({ dataLoading: false });
    }

    currentSession.showId = showId;
  };

  private synchronize = () => {
    const showSync = new ShowSyncModel({
      id: showDashboardStore.showModel.id,
    });
    showSync.set('immediate', true);
    showSync
      .save({ method: 'POST' })
      .then(() => {
        this.setState({ synchronized: true });
        notification.success({
          title: formatMessageIntl("Synchronisation effectuée !"),
        });
        showDashboardStore.showModel.fetch();
      })
      .catch(() => {
        notification.error({
          title: formatMessageIntl("La synchronisation a échoué..."),
        });
      });
  };
}

const WrappedShowDashboard = withNavigation(ShowDashboard);

export default WrappedShowDashboard;
